<template>
  <svg
    class="badge-year-parts"
    width="20"
    height="26"
    viewBox="0 0 20 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5_314)">
      <path opacity="0.7" d="M0.5 0H9L12.5056 10H4.0056L0.5 0Z" fill="url(#paint0_linear_5_314)" />
      <path d="M19.5 0H11.0056L7.5 10H15.9944L19.5 0Z" fill="url(#paint1_linear_5_314)" />
      <g filter="url(#filter0_d_5_314)">
        <path
          d="M10 26C15.5228 26 20 21.5228 20 16C20 10.4772 15.5228 6 10 6C4.47715 6 0 10.4772 0 16C0 21.5228 4.47715 26 10 26Z"
          fill="#D3D3D3"
        />
        <path
          d="M10 23.5C14.1421 23.5 17.5 20.1421 17.5 16C17.5 11.8579 14.1421 8.5 10 8.5C5.85786 8.5 2.5 11.8579 2.5 16C2.5 20.1421 5.85786 23.5 10 23.5Z"
          stroke="black"
          stroke-opacity="0.1"
        />
        <text transform="matrix(1 0 0 1 10 19.5)" text-anchor="middle" fill="black">
          {{ badgeYear }}
        </text>
      </g>
    </g>

    <defs>
      <filter
        id="filter0_d_5_314"
        x="-8"
        y="0"
        width="36"
        height="36"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5_314" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5_314" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_5_314"
        x1="0.5"
        y1="10"
        x2="12.5056"
        y2="10"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A69C" />
        <stop offset="1" stop-color="#00A69C" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5_314"
        x1="19.5"
        y1="10"
        x2="7.5"
        y2="10"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A69C" />
        <stop offset="1" stop-color="#00A69C" />
      </linearGradient>
      <clipPath id="clip0_5_314">
        <rect width="20" height="26" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { BadgeData } from '@/components/MypageTopPage/MembershipCardPane/parts/MemberBadgeItemParts.vue'

/**
 * マイページ: 会員証 登録年数バッヂパーツ
 */
export default defineComponent({
  name: 'BadgeYearParts',
  props: {
    badge: {
      type: Object as PropType<BadgeData>,
      required: true,
    },
  },
  setup(props) {
    const badgeYear = computed(() => props.badge.years)

    return {
      badgeYear,
    }
  },
})
</script>

<style lang="scss" scoped>
.badge-year-parts {
  text {
    font-family: $fontFamilyDefault;
    font-size: 10px;
    font-weight: 600;
  }
}
</style>
